import constants from '../Utils/constants';
const initialState = {
  isOrderProcessloading: false,
  allOrderProcess: [],
  allOrderProcessNotifications: [],
  allDynamicOrderClips: [],
  isCreateOrderProcessoading: false,
  isDeleteOrderProcessLoading: false,
  isUpdateOrderProcessLoading: false,
  setOrderProcessId: '',
  OrderProcess: {},
  OrderProcessNotification: {},
  isOrderProcessByIdLoading: false,
  isDynamicOrderClipsloading: false,
  isOrderProcessNotificationsloading: false,
  isCreateOrderProcessNotificationLoading: false,
  isDeleteOrderProcessNotificationLoading: false,
  isUpdateOrderProcessNotificationLoading: false,
};

export const orderProcessReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ORDER_PROCESS_REQUEST:
      return {
        ...state,
        isOrderProcessloading: true,
      };
    case constants.GET_ORDER_PROCESS_SUCCESS:
      return {
        ...state,
        isOrderProcessloading: false,
        allOrderProcess: action.payload,
      };
    case constants.GET_ORDER_PROCESS_FAILURE:
      return {
        ...state,
        isOrderProcessloading: false,
      };
    case constants.CREATE_ORDER_PROCESS_REQUEST:
      return {
        ...state,
        isCreateOrderProcessoading: true,
      };
    case constants.CREATE_ORDER_PROCESS_SUCCESS:
      return {
        ...state,
        isCreateOrderProcessoading: false,
      };
    case constants.CREATE_ORDER_PROCESS_FAILURE:
      return {
        ...state,
        isCreateOrderProcessoading: false,
      };
    case constants.DELETE_ORDER_PROCESS_REQUEST:
      return {
        ...state,
        isDeleteOrderProcessLoading: true,
      };
    case constants.DELETE_ORDER_PROCESS_SUCCESS:
      return {
        ...state,
        isDeleteOrderProcessLoading: false,
      };
    case constants.DELETE_ORDER_PROCESS_FAILURE:
      return {
        ...state,
        isDeleteOrderProcessLoading: false,
      };
    case constants.UPDATE_ORDER_PROCESS_REQUEST:
      return {
        ...state,
        isUpdateOrderProcessLoading: true,
      };
    case constants.UPDATE_ORDER_PROCESS_SUCCESS:
      return {
        ...state,
        isUpdateOrderProcessLoading: false,
      };
    case constants.UPDATE_ORDER_PROCESS_FAILURE:
      return {
        ...state,
        isUpdateOrderProcessLoading: false,
      };
    case constants.REORDER_ORDER_PROCESS_REQUEST:
      return {
        ...state,
        isUpdateOrderProcessLoading: true,
      };
    case constants.REORDER_ORDER_PROCESS_SUCCESS:
      return {
        ...state,
        isUpdateOrderProcessLoading: false,
      };
    case constants.REORDER_ORDER_PROCESS_FAILURE:
      return {
        ...state,
        isUpdateOrderProcessLoading: false,
      };
    case constants.GET_ORDER_PROCESS_BY_ID_REQUEST:
      return {
        ...state,
        isOrderProcessByIdLoading: true,
      };
    case constants.GET_ORDER_PROCESS_BY_ID_SUCCESS:
      return {
        ...state,
        isOrderProcessByIdLoading: false,
        OrderProcess: action.payload,
      };
    case constants.GET_ORDER_PROCESS_BY_ID_FAILURE:
      return {
        ...state,
        isOrderProcessByIdLoading: false,
      };
    case constants.GET_SELECTED_ORDER_PROCESS_ID:
      return {
        ...state,
        setOrderProcessId: action.payload,
      };
    case constants.GET_ORDER_PROCESS_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isOrderProcessNotificationsloading: true,
      };
    case constants.GET_ORDER_PROCESS_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isOrderProcessNotificationsloading: false,
        allOrderProcessNotifications: action.payload,
      };
    case constants.GET_ORDER_PROCESS_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isOrderProcessNotificationsloading: false,
      };
    case constants.GET_DYNAMIC_ORDER_CLIPS_REQUEST:
      return {
        ...state,
        isDynamicOrderClipsloading: true,
      };
    case constants.GET_DYNAMIC_ORDER_CLIPS_SUCCESS:
      return {
        ...state,
        isDynamicOrderClipsloading: false,
        allDynamicOrderClips: action.payload,
      };
    case constants.GET_DYNAMIC_ORDER_CLIPS_FAILURE:
      return {
        ...state,
        isDynamicOrderClipsloading: false,
      };
    case constants.CREATE_ORDER_PROCESS_NOTIFICATION_REQUEST:
      return {
        ...state,
        isCreateOrderProcessNotificationLoading: true,
      };
    case constants.CREATE_ORDER_PROCESS_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isCreateOrderProcessNotificationLoading: false,
      };
    case constants.CREATE_ORDER_PROCESS_NOTIFICATION_FAILURE:
      return {
        ...state,
        isCreateOrderProcessNotificationLoading: false,
      };
    case constants.DELETE_ORDER_PROCESS_NOTIFICATION_REQUEST:
      return {
        ...state,
        isDeleteOrderProcessNotificationLoading: true,
      };
    case constants.DELETE_ORDER_PROCESS_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isDeleteOrderProcessNotificationLoading: false,
      };
    case constants.DELETE_ORDER_PROCESS_NOTIFICATION_FAILURE:
      return {
        ...state,
        isDeleteOrderProcessNotificationLoading: false,
      };
    case constants.UPDATE_ORDER_PROCESS_NOTIFICATION_REQUEST:
      return {
        ...state,
        isUpdateOrderProcessNotificationLoading: true,
      };
    case constants.UPDATE_ORDER_PROCESS_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isUpdateOrderProcessNotificationLoading: false,
      };
    case constants.UPDATE_ORDER_PROCESS_NOTIFICATION_FAILURE:
      return {
        ...state,
        isUpdateOrderProcessNotificationLoading: false,
      };
    case constants.GET_ORDER_PROCESS_NOTIFICATION_BY_ID_REQUEST:
      return {
        ...state,
        isOrderProcessNotificationByIdLoading: true,
      };
    case constants.GET_ORDER_PROCESS_NOTIFICATION_BY_ID_SUCCESS:
      return {
        ...state,
        isOrderProcessNotificationByIdLoading: false,
        OrderProcessNotification: action.payload,
      };
    case constants.GET_ORDER_PROCESS_NOTIFICATION_BY_ID_FAILURE:
      return {
        ...state,
        isOrderProcessNotificationByIdLoading: false,
      };
    default:
      return state;
  }
};
